import(/* webpackMode: "eager" */ "/tmp/build_81f94c18/src/app/encomendas/[order_id]/page.tsx");
